import React, { createContext } from 'react'

/**
 * Context global state and prop injection handling for private modal routes
 * Helps passing data to child components
 * @param {object} props
 * @param {object} props.value - Context expects a value object by nature
 * @param {boolean} props.value.loggedIn - Is user logged in
 * @param {object} props.value.currentUser - Current user object
 * @param {boolean} props.value.isModalPath - Is this a modal path
 * @param {boolean} props.value.primaryRouteIsPrivate - Is the user already within a private route in the main application router
 * @param {React.ReactNode} props.children - Child component(s) to be rendered inside the Context provider
 */

const ModalRouterContext = createContext()

const ModalRouterProvider = ({ value, children }) => {
    return (
        <ModalRouterContext.Provider
            value={value}
        >
            {children}
        </ModalRouterContext.Provider>
    )
}

export default ModalRouterContext

export { ModalRouterProvider }
